export default __webpack_public_path__ + "static/voutes_image-b6882631e2b4c167819c99061b713f69.jpg";